import { UserManagementActionTypes } from 'src/store/actions';
import { UserManagementState } from '../initial.state';

function userReducer(state = new UserManagementState(), action) {
  switch (action.type) {
    case UserManagementActionTypes.LOAD_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.data,
      };

    case UserManagementActionTypes.LOAD_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload.data,
      };

    case UserManagementActionTypes.LOAD_COURSE_SUCCESS:
      return {
        ...state,
        courses: action.payload.data,
      };

    case UserManagementActionTypes.SAVE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(user => {
          if (user.userId !== action.payload.userId) {
            return user;
          }
          return {
            ...user,
            ...action.payload,
          };
        }),
      };

    case UserManagementActionTypes.ADD_USER_SUCCESS:
      return {
        ...state,
        users: [action.payload, ...state.users],
      };

    default:
      return state;
  }
}

export { userReducer };
